import { useTranslation } from "react-i18next";
import { FaCheck } from "react-icons/fa";
import "./AboutStyle.css";
import aboutUs from "../../assets/aboutUs.png";

const About = ({ id }) => {
  const { t, i18n } = useTranslation();

  return (
    <section className="about-section" id={id}>
      <h1 className="section-title">{t("aboutUs.title")}</h1>
      <div
        className={`about-content ${
          i18n.language === "ar" ? "rtl-layout" : ""
        }`}
      >
        <div className="text-container">
          <h2 className="sub-title">{t("aboutUs.subTitle")}</h2>
          <h4 className="sub-head">{t("aboutUs.subHead")}</h4>
          <p className="about-desc">{t("aboutUs.description")}</p>
          <ul className="features-list">
            <li>
              <FaCheck className="check-icon" />{" "}
              {t("aboutUs.features.affordable")}
            </li>
            <li>
              <FaCheck className="check-icon" />{" "}
              {t("aboutUs.features.reliable")}
            </li>
          </ul>
          <blockquote className="quote">
            <p>
              <em>“{t("aboutUs.quote.text")}”</em>
            </p>
          </blockquote>
        </div>
        <div className="image-container">
          <img className="image-placeholder" src={aboutUs} alt="About Us" />
        </div>
      </div>
    </section>
  );
};

export default About;
